
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockDisassembleDtGrid extends Serenity.EntityGrid<IcStockDisassembleDtRow, any> {
        protected getColumnsKey() { return IcStockDisassembleDtColumns.columnsKey; }
        protected getDialogType() { return IcStockDisassembleDtDialog; }
        protected getIdProperty() { return IcStockDisassembleDtRow.idProperty; }
        protected getInsertPermission() { return IcStockDisassembleDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockDisassembleDtRow.localTextPrefix; }
        protected getService() { return IcStockDisassembleDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}